import React, {useEffect, useRef} from 'react';
import CurrencyInputComponent from './CurrencyInputComponent';
import Debouncing from './Debouncing';

const DebouncingCurrencyInput = ({placeholder, defaultValue, onChange}) => {
    const didMountRef = useRef(false);
    const [debounceValue, setValue,actualValue] = Debouncing('', 1000)


    useEffect(() => {
        if (didMountRef.current) {

            onChange(debounceValue)

        } else {
            didMountRef.current = true;
        }


    }, [debounceValue,onChange])

    useEffect(() => {
        setValue(defaultValue)
    }, [defaultValue,setValue])
    return (

        <CurrencyInputComponent
            onChange={(e) => {
                setValue(e)
            }}

            value={actualValue}
            defaultValue={defaultValue} placeholder={placeholder}/>

    );
};

export default DebouncingCurrencyInput;